import { render, staticRenderFns } from "./CmgAccountModalJoinRewards.vue?vue&type=template&id=4a954191&scoped=true&lang=pug&"
import script from "./cmg-account-modal-join-rewards.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-join-rewards.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalJoinRewards.vue?vue&type=style&index=0&id=4a954191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a954191",
  null
  
)

export default component.exports